module.exports = __webpack_public_path__ + "static/media/slidee-6.8e40f82f.jpg";